import { reactive } from "vue";

const EventBus = reactive({
  accentColor: "#000000",
  accentBold: true,
});

export default EventBus;